import React, { useState, useEffect } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import kaiaLogo from '../assets/image/kaia_logo.png';
import { useAuth } from '../contexts/AuthContext';
import styles from './LoginPage.module.css';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const { login } = useAuth();
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [isEmployee, setIsEmployee] = useState(false);
    const [rememberId, setRememberId] = useState(false);

    useEffect(() => {
        const savedUsername = localStorage.getItem('rememberedUsername');
        if (savedUsername) {
            setUsername(savedUsername);
            setRememberId(true);
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        const result = await login(username, password);

        if (result.success) {
            // 로그인 성공 시 '아이디 저장' 로직 처리
            if (rememberId) {
                localStorage.setItem('rememberedUsername', username);
            } else {
                localStorage.removeItem('rememberedUsername');
            }
            // App.jsx의 useEffect가 로그인 후 나머지 작업을 처리합니다.
        } else {
            // 로그인 실패 시 에러 메시지 표시
            setError(result.error);
        }
    };

    return (
        <div className={styles['login-page']}>
            <div className={styles['login-card']}>
                <div style={{ marginBottom: '2.5rem' }}>
                    <img src={kaiaLogo} alt="KAIA Logo" style={{ width: '250px', margin: '0 auto 1.5rem', display: 'block' }} />
                    <hr style={{ border: 0, borderTop: '1px solid #e5e7eb' }} />
                </div>

                <div className={styles['login-title-section']}>
                    <h1 className={styles['main-title']}>젖소 선형심사 계획교배 시스템</h1>
                    <p className={styles['sub-title']}>Korean Dairy Mating System</p>
                </div>

                {error && (
                    <div className={styles['login-error']}>
                        <strong style={{ fontWeight: 'bold' }}>로그인 실패!</strong>
                        <span style={{ display: 'block' }}> {error}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div>
                        <label htmlFor="username" style={{ display: 'block', marginBottom: '0.5rem', fontSize: '1rem', fontWeight: 'bold' }}>회원 ID</label>
                        <input
                            id="username"
                            type="text"
                            placeholder="회원번호를 입력하십시오"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            className="form-input"
                        />
                    </div>

                    <div>
                        <label htmlFor="password" style={{ display: 'block', marginBottom: '0.5rem', fontSize: '1rem', fontWeight: 'bold' }}>패스워드</label>
                        <div style={{ position: 'relative' }}>
                            <input
                                id="password"
                                type={showPassword ? 'text' : 'password'}
                                placeholder="패스워드를 입력하십시오"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="form-input"
                                style={{ paddingRight: '2.5rem' }}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className={styles['password-toggle']}
                                aria-label={showPassword ? "비밀번호 숨기기" : "비밀번호 보기"}
                            >
                                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                            </button>
                        </div>
                    </div>

                    <div className={styles['remember-me-section']}>
                        <label className={styles['checkbox-label']}>
                            <input
                                type="checkbox"
                                checked={rememberId}
                                onChange={(e) => setRememberId(e.target.checked)}
                                className={styles['checkbox-input']}
                            />
                            <span>로그인정보 저장</span>
                        </label>
                    </div>

                    <button
                        type="submit"
                        className="login-button"
                    >로그인</button>
                </form>

                <div className={styles['login-footer-info']}>
                    <p>본 프로그램의 접속정보는 본회 <span className={styles['highlight-red']}>홈페이지 회원정보와 동일 합니다.</span></p>
                    <p>"프로그램 문의 : <span className={styles['bold-text']}>02-588-9301</span>, 젖소개량부 : <span className={styles['bold-text']}>내선 210~212</span>"</p>
                </div>

                <div className={styles['login-find-account']}>
                    <span>아이디나 비밀번호를 잃어버리셨나요?</span>
                    <a
                        href="https://www.aiak.or.kr/ka_member/mem_find.jsp"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles['find-link']}
                    >
                        아이디/비밀번호 찾기
                    </a>
                </div>

                <div className={styles['login-find-account']}>
                    <span>아직 회원이 아니신가요?</span>
                    <a
                        href="https://www.aiak.or.kr/ka_member/mem_step1.jsp"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles['find-link']}
                    >
                        회원가입
                    </a>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
